import React, { useEffect, useState } from 'react';
import { t } from 'i18next';
import { Alert, Card, Col, Container, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { isEmpty, isString, join, map, findIndex, includes } from 'lodash';
import moment from 'moment';
import BackButton from '../../components/BackButton';
import DynamicForm from '../../components/DynamicForm';
import PatientInfoAccord from '../../components/Patient/patient-info-accord';
import Loader from '../../components/SplashScreen/loader';
import { addDischargeSummary, getDischargeSummaryFormFields, getPatientInfoDischarge } from '../../redux/discharge-clinical';
import { reset, changeDischargeSubFormList } from '../../redux/discharge-clinical/slice';
import useQuery from '../../utils/useQuery';
import { getDefaultFormID } from '../../utils/helper';

const DischargeSummary = () => {
	const [initialValues, setInitialValues] = useState({});
	const { currentHospital } = useSelector(state => state.auth);
	const { dischargeSummaryFormDetail, dischargeSummaryFormDetailError, dischargeSummaryAddResponse, dischargeSummaryAddError, currentPatientDetail, Loading } = useSelector(state => state.dischargeClinical);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { patientId, dsId } = useQuery();

	useEffect(() => {
		if (!isEmpty(currentHospital) && patientId > 0) {
			dispatch(getPatientInfoDischarge({ hospital_id: currentHospital.value, p_id: patientId }));
		}
		if (!isEmpty(currentHospital) && patientId > 0 && dsId === undefined) {
			dispatch(getDischargeSummaryFormFields({ hospital_id: currentHospital.value, default_form_id: getDefaultFormID('Discharge Summary'), p_id: patientId }));
		}
	}, [currentHospital]);

	useEffect(() => {
		if (!isEmpty(dischargeSummaryFormDetail?.form_fields)) {
			let fields = {};
			dischargeSummaryFormDetail?.form_fields.map((field) => {
				if (field.type == 'datetime') {
					fields[field.field_name] = moment(field.value, ['YYYY-MM-DD HH:mm']).format(moment.HTML5_FMT.DATETIME_LOCAL) || '';
				}
				else if (field.type == 'date') {
					fields[field.field_name] = moment(field.value, ['YYYY-MM-DD HH:mm']).format(moment.HTML5_FMT.DATE) || '';
				}
				else {
					fields[field.field_name] = field.value || '';
				}
			});
			setInitialValues(fields);
		}
	}, [dischargeSummaryFormDetail]);

	useEffect(() => {
		return () => {
			dispatch(reset());
		};
	}, []);

	useEffect(() => {
		if (!isEmpty(dischargeSummaryAddResponse) || !(patientId > 0)) {
			navigate('/discharge-clinical');
		}
	}, [dischargeSummaryAddResponse, patientId]);

	useEffect(() => {
		if (!isEmpty(dischargeSummaryAddError) || !isEmpty(dischargeSummaryFormDetailError)) {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		}
	}, [dischargeSummaryAddError, dischargeSummaryFormDetailError]);

	const backToList = () => {
		navigate('/discharge-clinical');
	};

	const handleAddDischargeSummarySubmit = (values) => {
		let formdata = new FormData();
		// formdata.append('form_id', dischargeSummaryFormDetail.id);
		// formdata.append('date_time', moment().format('YYYY-MM-DD HH:mm:ss'));
		formdata.append('hospital_id', currentHospital.value);
		formdata.append('p_id', patientId);
		formdata.append('formdata[form_unique_id]', dischargeSummaryFormDetail.form_unique_id);
		Object.entries(values).map((field) => {
			let fieldindex = findIndex(dischargeSummaryFormDetail?.form_fields, { 'field_name': field[0] });
			let fieldrule = [];
			if (fieldindex > -1) {
				fieldrule = dischargeSummaryFormDetail?.form_fields[fieldindex]?.field_rule?.split('|') || [];
			}
			formdata.append('formdata[' + field[0] + ']', field[1]);
			dischargeSummaryFormDetail.form_fields.map((formfield) => {
				if (formfield.field_name === field[0] && formfield.type === 'subform') {
					formdata.delete('formdata[' + field[0] + ']');
					formdata.append('formdata[' + field[0] + '][id]', formfield.sub_form_unique_id);
				}
				else if (formfield.field_name === field[0] && formfield.type === 'select') {
					if (!isString(field[1])) {
						formdata.delete('formdata[' + field[0] + ']');
						if (formfield.possible_values != '*') {
							formdata.append('formdata[' + field[0] + ']', field[1]?.value || '');
						}
						else {
							if (fieldrule && includes(fieldrule, 'split_pipe')) {
								formdata.append('formdata[' + field[0] + ']', join(field[1], '|'));
							}
							else {
								formdata.append('formdata[' + field[0] + ']', join(map(field[1], 'value'), ','));
							}
						}
					}
				}
				/* else if (formfield.field_name === field[0] && formfield.type === 'text' && formfield.autocomplete != '0') {
					formdata.delete('formdata[' + field[0] + ']');
					formdata.append('formdata[' + field[0] + ']', field[1]?.value || '');
				} */
			});
		});
		dispatch(addDischargeSummary(formdata));
	};
	const handleUpdateSubFormList = (values, fieldindex) => {
		dispatch(changeDischargeSubFormList({ values, fieldindex, mode: 'add' }));
	};

	return (
		<Container className='mt-4'>
			<Row>
				<Col className='d-flex justify-content-between'>
					<h5 className='text-primary'>
						{t('DISCHARGESUMMARY.TITLE')}
					</h5>
					<BackButton />
				</Col>
			</Row>
			<hr />
			{!Loading && <Row className='mt-4'>
				{!isEmpty(currentPatientDetail) && <PatientInfoAccord currentPatient={currentPatientDetail.patient_info.panel_title} currentPatientDetail={currentPatientDetail.patient_info.panel_details} patientUploadDetails={currentPatientDetail.patient_info.panel_upload_info} patientShfitLogDetails={currentPatientDetail.patient_info.panel_shiftlog} />}
			</Row>}
			<Row className='mt-4'>
				<Col>
					{(dischargeSummaryFormDetailError || dischargeSummaryAddError) &&
						<Alert variant='danger'>
							<ul className='mb-0'>
								{dischargeSummaryFormDetailError && dischargeSummaryFormDetailError.split('|').map((error, index) => (
									<li key={index}>{error}</li>
								))}
								{dischargeSummaryAddError && dischargeSummaryAddError.split('|').map((error, index) => (
									<li key={index}>{error}</li>
								))}
							</ul>
						</Alert>}
					{Loading &&
						<Row className='d-flex justify-content-center mt-4'>
							<Loader />
						</Row>}
					{dischargeSummaryFormDetail.form_fields && <Card text='dark' bg='white'>
						<Card.Header className='text-uppercase'>
							{dischargeSummaryFormDetail.name}
						</Card.Header>
						<Card.Body>
							{!isEmpty(initialValues) && <DynamicForm ReInitialize={false} initialValues={initialValues} fields={dischargeSummaryFormDetail.form_fields} handleCancel={backToList} handleSubmit={handleAddDischargeSummarySubmit} parentformuniqueid={dischargeSummaryFormDetail.form_unique_id} handleUpdateSubFormList={handleUpdateSubFormList} loading={Loading} isClinicalDischargeForm={true} />
							}
						</Card.Body>
					</Card>}
				</Col>
			</Row>
		</Container >
	);
};

export default DischargeSummary;